import _get from 'lodash/get'

const config = {
    googleMaps: {
        key: _get(window, 'RB_WC_CONFIG.googleMaps.key', 'AIzaSyDenL0PBZS_slHcVgHgJALfKYXR_xED5rw'),
        apiKey: _get(window, 'RB_WC_CONFIG.googleMaps.key', 'AIzaSyDenL0PBZS_slHcVgHgJALfKYXR_xED5rw'),
    },
    runbuggy: {
        api: {
            token: _get(window, 'RB_WC_CONFIG.runbuggy.api.token', 'ak29ii3g0vcn6jm1k232ut54dttm7q3p'),
            path: _get(window, 'RB_WC_CONFIG.runbuggy.api.path', 'https://legacy.runbuggy.com/api/runbuggy/api')
        }
    },
    camunda: {
        api: {
            path: _get(window, 'RB_WC_CONFIG.camunda.api.path', 'https://apps.runbuggy.com/runbuggy/onboarding/rest/engine/default')
        },
        enableAuth: _get(window, 'RB_WC_CONFIG.camunda.enableAuth', true)
    },
    workflow: {
        api: {
            token: _get(window, 'RB_WC_CONFIG.workflow.api.token', 'ak29ii3g0vcn6jm1k232ut54dttm7q3p'),
            path: _get(window, 'RB_WC_CONFIG.workflow.api.path', 'https://apps.runbuggy.com/runbuggy/orders-workflow')
        }
    },
    accounts: {
        api: {
            path: _get(window, 'RB_WC_CONFIG.accounts.api.path', 'https://apps.runbuggy.com/runbuggy/accounts')
        }
    },
    stripe: {
        key: 'pk_live_7BWpbjRO7wxq64l5cc6PnFJ3',
        apiKey: 'pk_live_7BWpbjRO7wxq64l5cc6PnFJ3'
    }
};

window.RUNBUGGY_FORMS_RENDERER_CONFIG = config;
export default config;
